module.exports = function() {
  return new Worker(__webpack_public_path__ + "web-worker.6910fc4402710453ebb1.js");
};